/** Public marketing site (accueil, services, FAQ, secteurs, soumission, pages légales). */
export default {
  nav: {
    services: 'Services',
    how: 'Comment ça marche',
    quote: 'Soumission',
    sectors: 'Secteurs',
    faq: 'FAQ',
    about: 'À propos',
    login: 'Connexion',
    cta: 'Demander une soumission',
    myAccount: 'Mon espace',
    menu: 'Menu',
    language: 'Changer de langue',
    otherLanguage: 'English',
    home: 'Accueil Ménage Éclat',
  },
  meta: {
    homeTitle: 'Ménage Éclat · Ménage résidentiel et commercial, Rive-Sud et Montréal',
    homeDescription: 'Service de ménage résidentiel et commercial fiable sur la Rive-Sud et à Montréal. Soumission en ligne, même équipe, suivi de vos visites depuis votre espace client.',
    servicesTitle: 'Nos services de ménage',
    servicesDescription: 'Ménage résidentiel, récurrent, nettoyage en profondeur, déménagement, commercial et services personnalisés.',
    faqTitle: 'Questions fréquentes',
    faqDescription: 'Présence, clés, animaux, modifications, annulation, prix : les réponses à vos questions sur notre service de ménage.',
    sectorsTitle: 'Secteurs desservis',
    sectorsDescription: 'Les secteurs de la Rive-Sud et de Montréal où nos équipes se déplacent.',
    quoteTitle: 'Obtenir ma soumission',
    quoteDescription: 'Décrivez votre propriété en quelques étapes et obtenez une estimation immédiate.',
    aboutTitle: 'À propos',
    aboutDescription: 'Une équipe stable et attentionnée, et des outils simples pour suivre votre service.',
  },
  hero: {
    eyebrow: 'Rive-Sud et Montréal',
    title: 'Une maison propre, sans y penser.',
    subtitle: 'Un service de ménage résidentiel et commercial fiable sur la Rive-Sud et Montréal. Réservez simplement, suivez vos visites et gérez votre service depuis votre espace client.',
    cta: 'Demander une soumission',
    login: 'Se connecter',
    services: 'Voir nos services',
    imageAlt: 'Salon lumineux et rangé, canapé blanc et plantes vertes',
    nextTitle: 'Prochain ménage',
    nextWhen: 'Mardi 10:00',
    nextTeam: 'Équipe Julie & Marie',
    doneTitle: 'Ménage terminé',
    doneText: 'Toutes les tâches complétées',
  },
  trust: {
    team: { title: 'Équipe fiable', text: 'Les mêmes personnes, visite après visite' },
    insured: { title: 'Service assuré', text: 'Des instructions respectées et suivies' },
    booking: { title: 'Réservation simple', text: 'Soumission en ligne en quelques minutes' },
    tracking: { title: 'Suivi en ligne', text: 'Horaire, messages et historique' },
  },
  services: {
    eyebrow: 'Nos services',
    title: 'Des solutions adaptées à tous vos besoins',
    more: 'Demander ce service',
    all: 'Voir tous les services',
    residential: {
      title: 'Ménage résidentiel',
      text: 'L’entretien complet de votre maison, condo ou appartement.',
      b1: 'Toutes les pièces, du sol aux surfaces',
      b2: 'Checklist suivie à chaque visite',
      b3: 'Vos consignes conservées',
      alt: 'Salon lumineux avec grande fenêtre',
    },
    recurring: {
      title: 'Ménage récurrent',
      text: 'Chaque semaine, aux deux semaines ou chaque mois.',
      b1: 'Même équipe autant que possible',
      b2: 'Rabais selon la fréquence',
      b3: 'Chaque visite modifiable',
      alt: 'Chambre claire au lit fait',
    },
    deep: {
      title: 'Nettoyage en profondeur',
      text: 'Un grand ménage : joints, plinthes, dessous des meubles.',
      b1: 'Cuisine et salles de bain à fond',
      b2: 'Détails souvent oubliés',
      b3: 'Idéal au changement de saison',
      alt: 'Évier de cuisine nettoyé avec un chiffon',
    },
    move: {
      title: 'Déménagement',
      text: 'Logement vide nettoyé avant l’arrivée ou après le départ.',
      b1: 'Intérieur des armoires',
      b2: 'Électroménagers',
      b3: 'Prêt pour la remise des clés',
      alt: 'Boîtes de déménagement dans un salon',
    },
    commercial: {
      title: 'Ménage commercial',
      text: 'Bureaux, cliniques et commerces, selon vos heures.',
      b1: 'En dehors de vos heures d’ouverture',
      b2: 'Fréquence sur mesure',
      b3: 'Instructions d’accès sécurisées',
      alt: 'Espace de bureau lumineux avec plantes',
    },
    custom: {
      title: 'Services personnalisés',
      text: 'Four, réfrigérateur, fenêtres, literie, sous-sol, armoires.',
      b1: 'Options à la carte',
      b2: 'Demandes particulières notées',
      b3: 'Prix confirmé dans la soumission',
      alt: 'Main gantée qui essuie une surface',
    },
  },
  how: {
    eyebrow: 'Comment ça marche',
    title: 'Une expérience simple en 4 étapes',
    s1: { title: 'Décrivez votre propriété', text: 'Type, pièces, animaux et préférences, une seule fois.' },
    s2: { title: 'Recevez votre soumission', text: 'Une estimation immédiate, puis un prix confirmé par notre équipe.' },
    s3: { title: 'Choisissez votre horaire', text: 'La date, l’heure et la fréquence qui vous conviennent.' },
    s4: { title: 'On s’occupe du reste', text: 'Votre équipe arrive préparée, vous suivez tout en ligne.' },
  },
  app: {
    eyebrow: 'Votre espace client',
    title: 'Tout gérer depuis votre espace',
    text: 'Votre service au même endroit, sur téléphone comme sur ordinateur.',
    f1: 'Prochain ménage et équipe',
    f2: 'Calendrier de vos visites',
    f3: 'Instructions et préférences',
    f4: 'Messages avec notre équipe',
    f5: 'Fiche de votre propriété',
    f6: 'Paiements en ligne (bientôt)',
    f7: 'Historique des ménages',
    previewLabel: 'Aperçu de l’espace client',
    previewHello: 'Bonjour Marie',
    previewNext: 'Prochain ménage',
    previewDate: 'Mardi 10 sept.',
    previewTime: '10:00 · 2 h 30',
    previewTeam: 'Julie & Marie',
    previewUpcoming: 'Prochains rendez-vous',
    previewQuote: 'Soumission à accepter',
    previewQuoteText: 'Nettoyage en profondeur',
    previewMessage: 'Julie : « On a bien noté pour le chien. »',
    previewChecklist: 'Checklist',
  },
  why: {
    eyebrow: 'Pourquoi nous',
    title: 'Pourquoi nous choisir ?',
    stable: { title: 'Équipe stable', text: 'Nous privilégions la continuité afin que les mêmes personnes connaissent votre maison.' },
    instructions: { title: 'Instructions conservées', text: 'Animaux, priorités, stationnement et demandes particulières restent attachés à votre propriété.' },
    simple: { title: 'Simple à gérer', text: 'Modifiez vos visites et consultez votre horaire depuis votre téléphone.' },
    clear: { title: 'Suivi clair', text: 'Vous savez quand votre ménage est prévu et quand il est terminé.' },
  },
  reviews: {
    eyebrow: 'Avis',
    title: 'Ce que disent nos clients',
    empty: 'Aucun avis publié pour l’instant.',
    emptyHint: 'Les avis de nos clients seront affichés ici dès qu’ils seront publiés.',
    demoBadge: 'Démo',
    demoNote: 'Exemples de démonstration, affichés seulement en mode développement.',
    d1: { name: 'Client démo A', text: 'Exemple d’avis : équipe ponctuelle, maison impeccable.' },
    d2: { name: 'Client démo B', text: 'Exemple d’avis : très pratique de tout suivre en ligne.' },
    d3: { name: 'Client démo C', text: 'Exemple d’avis : la même équipe à chaque visite.' },
  },
  sectors: {
    eyebrow: 'Secteurs desservis',
    title: 'Près de chez vous',
    text: 'Nos équipes se déplacent dans les secteurs suivants. Votre adresse n’y figure pas ? Demandez quand même une soumission.',
    empty: 'La liste des secteurs sera bientôt publiée.',
    mapAlt: 'Carte schématique des secteurs desservis',
  },
  quoteBand: {
    title: 'Obtenez votre soumission en quelques minutes',
    text: 'Quelques questions sur votre propriété, une estimation immédiate, puis un prix confirmé par notre équipe.',
    cta: 'Obtenir ma soumission',
  },
  faq: {
    eyebrow: 'FAQ',
    title: 'Questions fréquentes',
    more: 'Voir toutes les questions',
    q1: { q: 'Dois-je être présent lors du ménage ?', a: 'Non. Indiquez vos instructions d’accès (code de porte, boîte à clé, clé, concierge) dans la fiche de votre propriété. Ces informations sont chiffrées et ne sont visibles par l’équipe assignée qu’autour de la visite.' },
    q2: { q: 'Puis-je avoir la même équipe ?', a: 'Nous privilégions la continuité : l’assignation favorise les personnes qui connaissent déjà votre maison. Selon les disponibilités, une autre personne de l’équipe peut vous être assignée ; vous en êtes informé dans votre espace.' },
    q3: { q: 'Que dois-je préparer ?', a: 'Rangez les objets personnels qui traînent pour que l’équipe puisse nettoyer les surfaces. Indiquez dans votre fiche les pièces à ne pas entrer, vos priorités et les produits à utiliser ou à éviter.' },
    q4: { q: 'Avez-vous besoin d’une clé ?', a: 'Pas forcément. Vous pouvez choisir un code de porte, une boîte à clé, une clé remise, l’accès par le concierge ou une autre consigne, enregistrés de façon sécurisée.' },
    q5: { q: 'Que se passe-t-il avec mes animaux ?', a: 'Indiquez-les dans votre fiche avec vos consignes. L’équipe en est informée avant chaque visite et le temps prévu en tient compte.' },
    q6: { q: 'Puis-je modifier mon rendez-vous ?', a: 'Oui, directement dans votre espace client jusqu’à {{cutoff}} avant la visite. Passé ce délai, écrivez-nous dans la messagerie et nous ferons notre possible.' },
    q7: { q: 'Combien de temps avant dois-je annuler ?', a: 'Vous pouvez annuler en ligne jusqu’à {{cutoff}} avant l’heure prévue. Après ce délai, contactez-nous par la messagerie.' },
    q8: { q: 'Comment sont établis les prix ?', a: 'Selon le type de propriété, le nombre de chambres et de salles de bain, les étages, la superficie, les animaux, le type de ménage, les options et la fréquence (rabais pour un service régulier). L’estimation en ligne est indicative ; le prix officiel figure dans la soumission que vous acceptez.' },
    q9: { q: 'Puis-je demander des tâches particulières ?', a: 'Oui : choisissez des options comme l’intérieur du four ou du réfrigérateur, les fenêtres intérieures ou la literie, et ajoutez vos demandes particulières à la réservation.' },
    q10: { q: 'Offrez-vous des services récurrents ?', a: 'Oui : chaque semaine, aux deux semaines, chaque mois ou selon un intervalle personnalisé. Chaque visite reste modifiable individuellement et vous pouvez mettre le service en pause.' },
  },
  about: {
    eyebrow: 'À propos',
    title: 'Une équipe qui fait la différence',
    text: 'Nous croyons qu’un bon ménage repose sur la confiance : des personnes stables qui connaissent votre maison, des consignes respectées et une communication claire.',
    p1: 'Des équipes qui reviennent chez vous',
    p2: 'Des consignes conservées dans votre fiche',
    p3: 'Une checklist suivie à chaque visite',
    imageAlt: 'Employée de ménage souriante tenant un balai dans une cuisine',
  },
  footer: {
    tagline: 'Une maison propre, sans y penser.',
    company: 'Entreprise',
    services: 'Services',
    help: 'Aide',
    legal: 'Légal',
    contact: 'Contact',
    privacy: 'Politique de confidentialité',
    terms: 'Conditions d’utilisation',
    cancellation: 'Politique d’annulation',
    rights: 'Tous droits réservés.',
  },
  quote: {
    title: 'Obtenir ma soumission',
    subtitle: 'Quelques questions, une estimation immédiate. Aucun engagement.',
    stepOf: 'Étape {{n}} sur {{total}}',
    steps: { property: 'Type de propriété', details: 'Votre logement', service: 'Service et fréquence', summary: 'Résumé' },
    propertyQuestion: 'Quel type de propriété ?',
    detailsQuestion: 'Parlez-nous de votre logement',
    serviceQuestion: 'Quel service et à quelle fréquence ?',
    summaryQuestion: 'Votre estimation',
    bedrooms: 'Chambres',
    bathrooms: 'Salles de bain',
    floors: 'Étages',
    pets: 'Il y a des animaux à la maison',
    service: 'Type de ménage',
    frequency: 'Fréquence',
    extras: 'Options (facultatif)',
    back: 'Retour',
    next: 'Suivant',
    loading: 'Calcul de votre estimation…',
    range: 'Entre {{low}} et {{high}}',
    perVisit: 'par visite, taxes en sus',
    duration: 'Durée estimée : {{duration}}',
    disclaimer: 'Estimation indicative. Le prix officiel est confirmé par notre équipe dans votre soumission.',
    error: 'Nous n’avons pas pu calculer l’estimation. Veuillez réessayer.',
    retry: 'Réessayer',
    continue: 'Recevoir ma soumission officielle',
    continueHint: 'Créez votre compte (ou connectez-vous) : vos réponses sont conservées.',
    choose: 'Choisissez une option pour continuer.',
    summaryProperty: 'Propriété',
    summaryService: 'Service',
    rooms: '{{bedrooms}} ch. · {{bathrooms}} s. de bain · {{floors}} étage(s)',
    withPets: 'avec animaux',
    decrease: '{{label}} : retirer un',
    increase: '{{label}} : ajouter un',
  },
  legal: {
    draft: 'Contenu à valider avant la mise en production. Ce texte est un modèle et ne constitue pas un avis juridique.',
    updated: 'Dernière mise à jour : {{date}}',
    privacy: {
      title: 'Politique de confidentialité',
      intro: 'Nous protégeons les renseignements personnels que vous nous confiez, conformément à la Loi sur la protection des renseignements personnels dans le secteur privé du Québec (Loi 25).',
      s1: { h: 'Renseignements recueillis', p: 'Nom, courriel, téléphone, adresse des propriétés, caractéristiques du logement, préférences, instructions d’accès, historique des visites, messages et paiements.' },
      s2: { h: 'Utilisation', p: 'Planifier et réaliser les ménages, communiquer avec vous, facturer et améliorer le service. Nous ne vendons pas vos renseignements.' },
      s3: { h: 'Instructions d’accès', p: 'Les codes, clés et consignes d’alarme sont chiffrés. Seules les personnes autorisées y ont accès, et uniquement autour de la visite ; chaque consultation est journalisée.' },
      s4: { h: 'Conservation et hébergement', p: 'Les données sont hébergées au Canada et conservées le temps nécessaire aux fins indiquées et aux obligations légales.' },
      s5: { h: 'Vos droits', p: 'Vous pouvez demander l’accès, la rectification ou la suppression de vos renseignements, et retirer votre consentement, en nous écrivant.' },
      s6: { h: 'Responsable', p: 'Le responsable de la protection des renseignements personnels peut être joint aux coordonnées de l’entreprise indiquées au bas de cette page.' },
    },
    terms: {
      title: 'Conditions d’utilisation',
      intro: 'Ces conditions encadrent l’utilisation du site et de l’espace client.',
      s1: { h: 'Compte', p: 'Vous êtes responsable de l’exactitude de vos renseignements et de la confidentialité de votre mot de passe.' },
      s2: { h: 'Soumissions et prix', p: 'Les estimations en ligne sont indicatives. Le prix applicable est celui de la soumission acceptée.' },
      s3: { h: 'Rendez-vous', p: 'Les rendez-vous peuvent être modifiés ou annulés en ligne selon la politique d’annulation.' },
      s4: { h: 'Accès à la propriété', p: 'Vous vous engagez à fournir un accès sécuritaire et des consignes exactes.' },
      s5: { h: 'Responsabilité', p: 'Signalez tout problème dans les 48 heures suivant la visite par la messagerie de votre espace.' },
    },
    cancellation: {
      title: 'Politique d’annulation',
      intro: 'Nous comprenons que les imprévus arrivent.',
      s1: { h: 'Délai', p: 'Vous pouvez modifier ou annuler un ménage en ligne jusqu’à {{cutoff}} avant l’heure prévue.' },
      s2: { h: 'Après le délai', p: 'Écrivez-nous par la messagerie. Une annulation tardive ou une absence peut entraîner des frais, précisés dans votre soumission.' },
      s3: { h: 'Services récurrents', p: 'Chaque visite peut être modifiée individuellement. Vous pouvez mettre en pause ou annuler le service depuis votre espace, selon l’engagement prévu à votre entente.' },
    },
  },
  cutoffHours: '{{count}} heures',
  cutoffDays_one: '{{count}} jour ouvrable',
  cutoffDays_other: '{{count}} jours ouvrables',
};
